import './models';
import './h';
import * as Script from './script';
import './script-accommodation';
import {CheckAvailability} from './script-check-availability';
export { customPopUp } from './script-check-availability';
export { ResultPage, SuccessPage } from './script-result';
import './script-process-payment';
import './script-process-gift';
import './script-result';
import {ReviewCart} from './script-review-cart';
import * as SelectRoom from './script-select-room';
import { Accommodation } from './script-accommodation';
import { CookieCollection } from './script';

$(() => {
  Script.initialise();

  if (__DEV__) {
    const booking = CookieCollection.BookingDetails.get();
    let bookingHtml = '';
    if (booking) {
      bookingHtml = `<br/>Booking Id: ${booking.id}`;
    } else {
      bookingHtml = `<br/>Booking Id: undefined`;
    }

    $('body').append(`<div style="position: fixed; left: 0; top: 0; z-index: 9999; color: white; background-color: red; font-size: 12px; font-weight: bold;">Development Mode</div>`);
  }

  // accommondation.htm
  if ($('#AddRoom').length) {
    Accommodation();
  }

  // check-availability.htm
  let checkAvailability;
  const $calendar = $('#calendar');
  if ($calendar.length) {
    checkAvailability = new CheckAvailability($calendar);
    checkAvailability.initialise();
    return;
  }

  // select-room.htm
  if ($('#roomwrapper').length) {
    SelectRoom.run();
    return;
  }

  // review-cart.htm
  if ($('#cartrowwrapper').length) {
    ReviewCart();
    return;
  }
});
